import { assign } from 'lodash'

const development = {
  api: 'https://api-dev.qa-enphaseenergy.com',
}

const test = {
  api: 'https://api-dev.qa-enphaseenergy.com',
}

const qa4 = {
  api: 'https://api-dev.qa-enphaseenergy.com',
}

const intg = {
  api: 'https://api-intg.qa-enphaseenergy.com',
}

const rel = {
  api: 'https://api-rel.qa-enphaseenergy.com',
}

const qa2 = {
  api: 'https://api-qa2.enphaseenergy.com',
}

const production = {
  api: 'https://api.enphaseenergy.com',
}

const preprod = {
  api: 'https://api-preprod.enphaseenergy.com',
}

const local = {
  api: 'http://localhost:8080',
}

const DEFAULT = {}

const CONFIG = {
  development,
  production,
  preprod,
  test,
  qa2,
  intg,
  rel,
  qa4,
  local,
}

const getOauthConfig = (env) => {
  let hostname
  if (typeof window !== 'undefined') {
    hostname = window.location.hostname
    if (hostname.search('grid.enphaseenergy.com') >= 0) {
      env = 'production'
    } else if (hostname.search('grid-preprod.enphaseenergy.com') >= 0) {
      env = 'preprod'
    } else if (hostname.search('gs-console-stg.qa-enphaseenergy.com') >= 0) {
      env = 'qa2'
    } else if (hostname.search('gs-admin-ui-intg.qa-enphaseenergy.com') >= 0) {
      env = 'intg'
    } else if (hostname.search('grid-rel.qa-enphaseenergy.com') >= 0) {
      env = 'rel'
    } else if (hostname.search('gs-admin-ui-dev.qa-enphaseenergy.com') >= 0) {
      env = 'qa4'
    } else if (window.location.port === '8002') {
      env = 'qa4'
    } else {
      env = 'development'
    }
  } else if (env === 'test') {
    env = 'test'
  }

  const envConfig = CONFIG[env]
  if (envConfig) {
    return assign({}, DEFAULT, envConfig)
  }
  throw new Error('Unknown environment : ' + env)
}

export default getOauthConfig
